<template>
    <section class="g-wrapper">
        <header-com />
        <div style="margin: 50px 30px;">
            <h1>
                <span @click='$router.push({name:"agreement",query:{type:"three"}})'>包拯用户协议</span>
            </h1>
            <h1>
                <span @click='toShouqian'>包拯售前协议</span>
            </h1>
            <h1>
                <span @click='toShouhou'>包拯售后服务标准</span>
            </h1>
            <h1>
                <span @click='$router.push({name:"agreementStyle"})'>改样服务协议</span>
            </h1>
            
        </div>
        
    </section>
</template>

<script>
	export default {
		name: "agreement",
        data() {
		    return {
               
            }
        },
        created() {
           
        },

        methods:{
            toShouqian() {
                // this.$router.push({name:"agreement",query:{type:"two"}})
                window.open('https://mi.baozheng.cc/order/newShare/bzsq.pdf')
            },

            toShouhou() {
                window.open('https://mi.baozheng.cc/order/newShare/bzsh.pdf')
            }
        }
	}
</script>


<style scoped lang="scss">
    h1{
        
        line-height: 130px;
        span{
            color: #7adfdf!important;;
            text-decoration: underline;
        }
    }
</style>
